module.exports = __webpack_public_path__ + "static/media/traycorp8.ab97d104.png";